import AchievementPlayer from "../components/AchivementPlayer";

const AchievementPlayerInterface=()=>{
    return(
        <div >
        <AchievementPlayer/>
        </div>
    );
};
export default AchievementPlayerInterface;